@defer (on hover) {
  <div nz-tooltip [nzTooltipTitle]="tooltip" class="kpi_parent_container">
    <ng-container *ngTemplateOutlet="productivityValue"></ng-container>
  </div>
} @placeholder {
  <div class="kpi_parent_container">
    <ng-container *ngTemplateOutlet="productivityValue"></ng-container>
  </div>
}

<ng-template #productivityValue>
  <span class="kpi_title text-truncate">
    {{ 'page.shift_timeline.productivity.kpi' | translate }}
  </span>
  <div class="kpi-value-block">
    @if (!isLoadingProductivity) {
      @if (productivity) {
        <div>
          @if (productivity | productivityIcon; as icon) {
            <fa-icon
              [icon]="icon.name"
              [ngClass]="['ant-design-' + icon.color + '-5']"
            ></fa-icon>
          }
          <!-- this is dummy value and will be adjusted with BE integration -->
          <span class="kpi_value">
            {{ productivity + ' % ' }}
          </span>
        </div>
      } @else {
        <span class="kpi_value" nzType="secondary">
          {{ 'general.n/a' | translate }}
        </span>
      }
    } @else {
      <div class="skeleton-loading">
        <nz-skeleton
          [nzActive]="true"
          [nzParagraph]="{ rows: 1 }"
          [nzTitle]="false"
        ></nz-skeleton>
      </div>
    }
  </div>
</ng-template>

<ng-template #tooltip>
  <span class="fw-normal">
    {{ 'page.shift_timeline.productivity.kpi' | translate }}
  </span>
  <span class="d-block">
    {{
      'productivity_value.tooltip'
        | translate
          : {
              start: dateRange?.start | date: DATE_FORMAT,
              end: dateRange?.end | date: DATE_FORMAT,
            }
    }}
  </span>
</ng-template>
